import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemeService } from '@app/core/services/theme.service';

@Component({
    selector: 'app-navigation-wrapper',
    templateUrl: './app-navigation.component.html',
    styleUrls: ['./app-navigation.component.scss'],
    standalone: false
})
export class AppNavigationComponent {
  @Input() userName: string;
  @Input() appName: string;
  @Output() signout = new EventEmitter<void>();

  constructor(
    public themeService: ThemeService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'cfa-logo',
      sanitizer.bypassSecurityTrustResourceUrl('assets/cfa-logo.svg')
    );
  }

  get initials(): string {
    return (this.userName ?? '')
      .split(/[\s.@_-]+/)
      .filter(Boolean)
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }
}
